import UiListItem from "./UiListItem";
import MiezzListItem from "@/models/MiezzListItem";
import { EnumPipe } from "@/models/EnumPipe";
import { EnumParamAuditStatus, EnumParamAuditStatusOption } from "./EnumParamAuditStatus";

/**
 * 征免性质分页列表-项
 * @description 自动生成的代码,请勿修改
 */
export default class DtoListItemExemptionNature extends UiListItem<string> {
    constructor() {
        //无参构造函数
        super()
        this.Status = EnumParamAuditStatus.Not;
        this.IsEdit = false;
    }

    [proName: string]: any;
    /**
     * 名称
     */
    Abbr?: string;
    /**
     * 海关代码
     */
    Code?: string;
    /**
     * 全名
     */
    Name?: string;
    /**
     * 审核状态
     */
    Status?: EnumParamAuditStatus;
    /**
     * 是否可以编辑
     */
    IsEdit?: boolean;
    /**
     * 创建人所属公司
     */
    CreatedCompanyId?: string;
}

/**
 * 征免性质分页列表-项-表单校验
 */
export const DtoListItemExemptionNatureRules = {
}

/**
 * 征免性质分页列表-项-设置项
 */
export const DtoListItemExemptionNatureMiezzListItems: MiezzListItem[]  = [
  {
    Prop: "Abbr",
    Label: "名称",
  },
  {
    Prop: "Code",
    Label: "海关代码",
  },
  {
    Prop: "Name",
    Label: "全名",
  },
]
